import { render, staticRenderFns } from "./IconPageLg.vue?vue&type=template&id=e10a1ba0&"
import script from "./IconPageLg.vue?vue&type=script&lang=js&"
export * from "./IconPageLg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e10a1ba0')) {
      api.createRecord('e10a1ba0', component.options)
    } else {
      api.reload('e10a1ba0', component.options)
    }
    module.hot.accept("./IconPageLg.vue?vue&type=template&id=e10a1ba0&", function () {
      api.rerender('e10a1ba0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconPageLg.vue"
export default component.exports